import React from 'react';
import { InfoLinks } from 'components/molecules/infoLinks';
import { Image } from 'components/atoms/image';
import { useViewport } from 'components/templates/viewportProvider';
import { PdfButton } from 'components/atoms/pdfButton';
//eslint-disable-next-line
import styles from "./style.scss";

const ProjectAmenities = props => {
  const {
    media_path,
    web,
    thumbnail,
    amenity_image,
    project_amenities,
  } = props.props.data.data;
  const image_path = `${media_path}${web}/${amenity_image}`;
  const thumbNailUrl = `${media_path}${thumbnail}/${amenity_image}`;
  const { height } = useViewport();

  return (
    <div
      className={'property-amenities-body section-container overflow-visible'}
      style={{ height }}
    >
      <div className={'amenity_image'}>
        <Image src={image_path} thumbNail={thumbNailUrl} alt={'amenity'} />
      </div>
      <div className={'amenity-features-col'}>
        <div className={'amenity-features-body'}>
          <h1>Amenities</h1>
          <div className={'features'}>
            <InfoLinks
              links={project_amenities}
              connectRoute={false}
              selected_link={() => {}}
            />
          </div>
          {props.props.data && props.props.data.pdfUrl && (
            <PdfButton
              mode={'light'}
              className={'pdf-Button'}
              text={'DOWNLOAD BROCHURE'}
              onClick={() => window.open(props.props.data.pdfUrl, '_blank')}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default ProjectAmenities;
